import { render, staticRenderFns } from "./DeleteCenterDialog.vue?vue&type=template&id=1f2a727e&"
import script from "./DeleteCenterDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteCenterDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports